import { FileUploadInterface } from './Profile';

export interface ReceivingDelivery {
  id: string;
  receivingTitle: string;
  type: string;
  sender_Details: string;
  courier?: string;
  courier_Number?: string;
  mode_of_transport: string;
  mode_of_transport_number: string;
  date: string;
  receiver_Description: string;
  barcode_Package: string;
  isActive: boolean;
  isDeleted: boolean;
  verify_Status: string;
  customer_Name: string;
  files: FileUploadInterface[];
  // Tag & verify

  vaultlocation?: string;
  description?: string;
  barcode?: string;
}

export interface HFCShipperInfo{
  id: string;
  title: string;
  asset_ID: string;
  assetName?: string;
  print: string;
  vault: string;
  elementId: string;
  shipping_Date: string;
  return_Date: string;
  shipping_Location: string;
  theatreName?: string;
  theatreAddressLine1?: string;
  address: string;
  account: string;
  carrierAccount?: string;
  requested_By: string;
  requestBy?: string;
  requester_Email: string;
  requesterEmailId?: string;
  assets_Associated_with_Title_and_Asset_ID: string;
  associatedAssets?: string;
  notes: string;
}

export interface HFCServiceInfo{
  id: string;
  title: string;
  asset_ID: string;
  assetName?: string;
  print: string;
  vault: string;
  elementId: string;
  shipping_Date: string;
  return_Date: string;
  shipping_Location: string;
  theatreName?: string;
  theatreAddressLine1?: string;
  address: string;
  account: string;
  carrierAccount?: string;
  requested_By: string;
  requestBy?: string;
  requester_Email: string;
  requesterEmailId?: string;
  assets_Associated_with_Title_and_Asset_ID: string;
  associatedAssets?: string;
  notes: string;
  service:string;
}

export const HFCServiceInfoInitialdata = {
  id: "",
  title: "",
  asset_ID: "",
  print: "",
  vault: "",
  elementId: "",
  shipping_Date: "",
  return_Date: "",
  shipping_Location: "",
  address: "",
  account: "",
  requested_By: "",
  requester_Email: "",
  assets_Associated_with_Title_and_Asset_ID: "",
  notes: "",
  service:"",
};

export const HFCShipperInfoInitialdata = {
  id: "",
  title: "",
  asset_ID: "",
  print: "",
  vault: "",
  elementId: "",
  shipping_Date: "",
  return_Date: "",
  shipping_Location: "",
  address: "",
  account: "",
  requested_By: "",
  requester_Email: "",
  assets_Associated_with_Title_and_Asset_ID: "",
  notes: ""
};

export interface ReceivingDeliveryDelete {
  id: string;
  isDeleted: boolean;
}
export const ReceivingDeliveryInitialdata = {
  id: '',
  receivingTitle: '',
  type: '',
  sender_Details: '',
  mode_of_transport: '',
  mode_of_transport_number: '',
  date: '',
  receiver_Description: '',
  barcode_Package: '',
  verify_Status: 'Not Verified',
  customer_Name: '',
  isActive: false,
  isDeleted: false,
  files: [],
  vaultlocation: '',
  description: '',
  barcode: '',
};
